module.exports = __webpack_public_path__ + "media/images/icons/individual-achievement-4ef2ba576d536586f7ec42d020884e7a.svg";